import { ABOUT_YOU_URL, APPENDIX_URL } from "App.const";
import { Assertions } from "components/Assertions/Assertions";
import {
  AssertionAnswers,
  defaultPreAssertionAnswers,
} from "domain/assertions";
import { observer } from "mobx-react";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Store } from "state/store";
import { ASSERTION_SCREEN_TITLE } from "./Title.const";

export type AssertionsScreenProps = {
  store: Store;
};
const AssertionsScreen = ({ store }: AssertionsScreenProps) => {
  document.title = ASSERTION_SCREEN_TITLE;
  const [answers, setAnswers] = useState(defaultPreAssertionAnswers);
  const navigate = useNavigate();
  const { assertionsStore } = store;

  const handleWrongAnswer = useCallback(
    async (ans: AssertionAnswers = answers) => {
      const wrongAnswerIndex = ans.answers.findIndex(
        (answer) => answer.expected !== answer.answer
      );
      await assertionsStore.generateError(ans.answers[wrongAnswerIndex].type);
      navigate(APPENDIX_URL, { replace: true });
    },
    [assertionsStore, answers, navigate]
  );

  const handleSubmit = useCallback(
    async (ans: AssertionAnswers = answers) => {
      await assertionsStore.submitPreAssertions(ans);
      navigate(ABOUT_YOU_URL, { replace: true });
    },
    [assertionsStore, answers, navigate]
  );

  return (
    <>
      <Assertions
        questions={answers}
        onChange={setAnswers}
        onReady={handleSubmit}
        onWrongAnswer={handleWrongAnswer}
      />
    </>
  );
};

const AssertionsScreenObserver = observer(AssertionsScreen);

export { AssertionsScreenObserver as AssertionsScreen };
